var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-address-cascader"},[_c('el-cascader',{attrs:{"size":"small","props":_vm.props,"options":_vm.$store.state.regionData,"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.address_list),callback:function ($$v) {_vm.address_list=$$v},expression:"address_list"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce1d7de8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selectAddressCascader.vue
// module id = pXLy
// module chunks = 2